import { RouterModule, Routes } from "@angular/router";
import { NgModule } from "@angular/core";
import { MaintenceGuard } from "./utils/guards/maintence.guard";
import { HomeRedirectGuard } from "./utils/guards/home-redirect.guard";
import { AppCustomPreloader } from "./app-custom-preloader";

const APP_ROUTES: Routes = [
  {
    path: "estamos-en-mantenimiento",
    loadChildren: () =>
      import("./components/shared/mantenimiento-contacto/mantenmiento-contacto.component").then(
        (m) => m.MantenimientoContactoModule
      ),
  },


  {
    path: 'beneficios-clientes/referidos',
    loadChildren: () => import('./feat-referidos/smart-components/referidos-shell/referidos-shell-routing.module').then(m => m.ReferidosShellRoutingModule),
    canActivate: [MaintenceGuard]
  },
  {
    path: "",
    canActivate: [HomeRedirectGuard],
    canActivateChild: [HomeRedirectGuard],
    children: [
                  {
        path: "auto/seguros",
        canActivate: [MaintenceGuard],
        loadChildren: () => import("./feat-cotizar-auto-refactor/smart-components/cotizar-auto-shell/cotizar-auto-shell.routes").then((m) => m.cotizarAutoShellRoutes),
      },
      {
        path: "admin",
        loadChildren: () =>
          import("./components/admin/admin.module").then((m) => m.AdminModule),
      },

      {
        path: "seguros/provincias",
        loadChildren: () =>
          import("./pages/provincias/provincias.module").then(
            (m) => m.ProvinciasModule
          ),
      },
      {
        path: "seguros/localidades",
        loadChildren: () =>
          import("./pages/localidades/localidades.module").then(
            (m) => m.LocalidadesModule
          ),
      },

      { path: 'admin', loadChildren: () => import('./components/admin/admin.module').then(m => m.AdminModule) },
      //MOTO//MOTO//MOTO//MOTO//MOTO//MOTO//MOTO//MOTO//MOTO//MOTO//MOTO//MOTO//MOTO
      {
        path: "moto/seguros/proteger-mi-moto",
        //redirectTo: 'estamos-en-mantenimiento',
        loadChildren: () =>
          import("./pages/moto/datos-moto/datos-moto.module").then(
            (m) => m.DatosMotoModule
          ),
      },
      {
        path: "moto/seguros/marcas",
        loadChildren: () =>
          import("./pages/marcas/marcas.module").then((m) => m.MarcasModule),
      },
      {
        path: "moto/seguros/anios",
        loadChildren: () =>
          import("./pages/anios/anios.module").then((m) => m.AniosModule),
      },
      {
        path: "moto/seguros/modelos",
        loadChildren: () =>
          import("./pages/modelos/modelos.module").then((m) => m.ModelosModule),
      },
      {
        path: "moto/seguros/cero",
        loadChildren: () =>
          import("./pages/cero/cero.module").then((m) => m.CeroModule),
      },
      {
        path: "moto/seguros/datos-personales",
        loadChildren: () =>
          import("./pages/moto/datos-personales/datos-personales.module").then(
            (m) => m.DatosPersonalesMotoModule
          ),
      },
      {
        path: "moto/seguros/coberturas",
        loadChildren: () =>
          import("./pages/moto/coberturas/coberturas.module").then(
            (m) => m.CoberturasMotoModule
          ),
      },
      {
        path: "moto/seguros/datos-contratacion",
        loadChildren: () =>
          import("./pages/datos-contratacion/datos-contratacion.module").then(
            (m) => m.DatosContratacionModule
          ),
      },
      {
        path: "moto/seguros/resumen",
        loadChildren: () =>
          import("./pages/resumen/resumen.module").then((m) => m.ResumenModule),
      },
      {
        path: "moto/seguros/datos-personales-editar",
        loadChildren: () =>
          import(
            "./pages/datos-personales-editar/datos-personales-editar.module"
          ).then((m) => m.DatosPersonalesEditarModule),
      },
      {
        path: "moto/seguros/datos-moto-editar",
        loadChildren: () =>
          import(
            "./pages/moto/datos-moto-editar/datos-moto-editar.module"
          ).then((m) => m.DatosMotoEditarModule),
      },
      {
        path: "moto/seguros/pago",
        loadChildren: () =>
          import("./pages/pago/pago.module").then((m) => m.PagoModule),
      },
      {
        path: "moto/seguros/procesando-pago",
        loadChildren: () =>
          import("./pages/moto/procesando-pago/procesando-pago.module").then(
            (m) => m.MotoProcesandoPagoModule
          ),
      },
      {
        path: "moto/seguros/gracias-error",
        loadChildren: () =>
          import("./pages/moto/gracias-error/gracias-error.module").then(
            (m) => m.MotoGraciasErrorModule
          ),
      },

      //MOTO//MOTO//MOTO//MOTO//MOTO//MOTO//MOTO//MOTO//MOTO//MOTO//MOTO//MOTO//MOTO
      {
        path: 'moto/seguros/proteger-mi-moto',
        //redirectTo: 'estamos-en-mantenimiento',
        loadChildren: () => import('./pages/moto/datos-moto/datos-moto.module').then(m => m.DatosMotoModule)
      }, {
        path: 'moto/seguros/marcas',
        loadChildren: () => import('./pages/marcas/marcas.module').then(m => m.MarcasModule)
      }, {
        path: 'moto/seguros/anios',
        loadChildren: () => import('./pages/anios/anios.module').then(m => m.AniosModule)
      }, {
        path: 'moto/seguros/modelos',
        loadChildren: () => import('./pages/modelos/modelos.module').then(m => m.ModelosModule)
      }, {
        path: 'moto/seguros/cero',
        loadChildren: () => import('./pages/cero/cero.module').then(m => m.CeroModule)
      },
      {
        path: 'moto/seguros/datos-personales',
        loadChildren: () => import('./pages/moto/datos-personales/datos-personales.module').then(m => m.DatosPersonalesMotoModule),
      },
      {
        path: 'moto/seguros/coberturas',
        loadChildren: () => import('./pages/moto/coberturas/coberturas.module').then(m => m.CoberturasMotoModule)
      }, {
        path: 'moto/seguros/datos-contratacion',
        loadChildren: () => import('./pages/datos-contratacion/datos-contratacion.module')
          .then(m => m.DatosContratacionModule),
      }, {
        path: 'moto/seguros/resumen',
        loadChildren: () => import('./pages/resumen/resumen.module').then(m => m.ResumenModule)
      }, {
        path: 'moto/seguros/datos-personales-editar',
        loadChildren: () => import('./pages/datos-personales-editar/datos-personales-editar.module').then(m => m.DatosPersonalesEditarModule)
      }, {
        path: 'moto/seguros/datos-moto-editar',
        loadChildren: () => import('./pages/moto/datos-moto-editar/datos-moto-editar.module').then(m => m.DatosMotoEditarModule)
      }, {
        path: 'moto/seguros/pago',
        loadChildren: () => import('./pages/pago/pago.module').then(m => m.PagoModule)
      },

      //MOTO//MOTO//MOTO//MOTO//MOTO//MOTO//MOTO//MOTO//MOTO//MOTO//MOTO//MOTO//MOTO

      {
        path: "seguros/tarjetas",
        loadChildren: () =>
          import("./pages/tarjetas/tarjetas.module").then(
            (m) => m.TarjetasModule
          ),
      },
      {
        path: "seguros/bancos",
        loadChildren: () =>
          import("./pages/bancos/bancos.module").then((m) => m.BancosModule),
      },

      {
        path: "seguros/dia-nacimiento",
        loadChildren: () =>
          import("./pages/dia-nacimiento/dia-nacimiento.module").then(
            (m) => m.DiaNacimientoModule
          ),
      },
      {
        path: "seguros/mes-nacimiento",
        loadChildren: () =>
          import("./pages/mes-nacimiento/mes-nacimiento.module").then(
            (m) => m.MesNacimientoModule
          ),
      },
      {
        path: "seguros/anio-nacimiento",
        loadChildren: () =>
          import("./pages/anio-nacimiento/anio-nacimiento.module").then(
            (m) => m.AnioNacimientoModule
          ),
        // }, {
        //   path: 'auto/seguros/guardar-cobertura',
        //   loadChildren: () => import('./pages/guardar-cobertura/guardar-cobertura.module').then(m => m.GuardarCoberturaModule)
      },

      {
        path: "homeold",
        loadChildren: () =>
          import("./pages/home/home.module").then((m) => m.HomeModule),
      },
      {
        path: "",
        loadChildren: () =>
          import("./pages/container/container.module").then(
            (m) => m.ContainerModule
          ),
        
      },
      {
        path: "gracias-landings",
        loadChildren: () =>
          import("./pages/gracias-landings/gracias-landings.module").then(
            (m) => m.GraciasLandingsModule
          ),
      } /*, {
    path: 'contacto',
    // loadChildren: () => import('./pages/contacto/contacto.module').then(m => m.ContactoModule)
    //loadChildren: () => import('./pages/formulario/formulario.module').then(m => m.FormularioModule),
  },*/,
      {
        path: "vida",
        loadChildren: () =>
          import("./pages/seguros/seguros-vida/seguros-vida.module").then(
            (m) => m.VidaModule
          ),
      },
      // {
      //   path: "hogar",
      //   loadChildren: () =>
      //     import("./pages/seguros/seguros-hogar/seguros-hogar.module").then(
      //       (m) => m.SegurosHogarModule
      //     ),
      // },
      {
        path: "moto",
        loadChildren: () =>
          import("./pages/seguros/seguros-motos/seguros-motos.module").then(
            (m) => m.SegurosMotosModule
          ),
      },

      {
        path: "preguntas-frecuentes",
        loadChildren: () =>
          import(
            "./pages/preguntas-frecuentes/preguntas-frecuentes.module"
          ).then((m) => m.PreguntasFrecuentesModule),
      },
      {
        path: "terminos-y-condiciones",
        loadChildren: () =>
          import("./pages/tyc/tyc.module").then((m) => m.TyCModule),
      },
    ],
  },

];

@NgModule({
  exports: [RouterModule],
  providers: [AppCustomPreloader],
  imports: [
    RouterModule.forRoot(APP_ROUTES, {
      onSameUrlNavigation: "ignore",
      anchorScrolling: "enabled",
      scrollPositionRestoration: "enabled",
      //relativeLinkResolution: "legacy",
    }),
  ],
  // exports: [RouterModule]
})
export class AppRoutingModule { }
